<div class="container">
    <div class="position-absolute pos-abs filter-margin">
        <p-button (click)="showDialog()" icon="pi pi-filter" [styleClass]="'bg-color-1 text-light p-button-lg btn-wd'"
            [style]="{
            '--color-1' : colors[0],
            '--color-2' : colors[1],
            '--color-3' : colors[2],
            '--color-4' : colors[3],
            '--color-5' : colors[4]
        }"></p-button>
    </div>
</div>
<p-dialog [blockScroll]="true" [draggable]="false"header="الجهات" [modal]="true" styleClass="bg-dark" [(visible)]="visible" (onHide)="submitFilter()"
    [style]="{width: '50vw'}">
    <!-- breadcrumb -->
    <div class="d-flex flex-row w-100 left-0 pb-2 wrapp">
        <ng-container *ngIf="current && current.breadcrumbs && current.breadcrumbs.length > 0">
            <span class="d-flex flex-row align-items-center" *ngFor="let parent of sortByDepth(current?.breadcrumbs)">
                <span class="btn-flex custom-bredcrum-btn ou-item  align-items-center">
                    <span class="btn-css  mx-2 font-0_5rem" role="button"
                        [routerLink]="'/category/'+parent.id">{{parent.name}}</span>
                    <span class="icon-box">
                        <img src="{{staticURL + parent?.image_sq}}" *ngIf="checkisImg(parent?.image_sq); else elseBlock"
                            class="img-fluid" alt="">
                        <ng-template #elseBlock>
                            <i class="pi pi-{{parent.image}} img-fluid"></i>
                        </ng-template>
                    </span>
                </span>
                <span>
                    <i class="pi pi-fw pi-angle-left"></i>
                </span>
            </span>
        </ng-container>
        <span class="btn-flex mx-1 ou-item active custom-bredcrum-btn align-items-center">
            <span role="button" class="btn-css mx-2 font-0_5rem"
                [routerLink]="'/category/'+current?.id">{{current?.name}}</span>
            <span class="icon-box">
                <img src="{{staticURL + current?.image_sq}}" *ngIf="checkisImg(current?.image_sq); else elseBlock"
                    class="img-fluid" alt="">
                <ng-template #elseBlock>
                    <i class="pi pi-{{current?.image}} align-self-center"></i>
                </ng-template>
            </span>
        </span>
    </div>
    <!-- breadcrumb end -->
    <div class="container">
        <div class="d-flex flex-row align-items-center gap-4 my-5 flex-wrap justify-content-start">
            <p-button [disabled]="!checkEnabled()" (click)="reverse()"
                class="bg-opacity-75 bg-light d-flex flex-column justify-content-center align-items-center py-3 px-5 text-dark text-center">
                <i class="pi pi-angle-right" style="font-size: 2rem;"></i>
            </p-button>

            <!-- <div (click)="changeData(current)" *ngIf="current && current != undefined" [style]="{
                    '--color-1' : colors[0],
                    '--color-2' : colors[1],
                    '--color-3' : colors[2],
                    '--color-4' : colors[3],
                    '--color-5' : colors[4],
                    'cursor': 'pointer',
                     'height': 'auto'
                }" class="card bg-primary d-flex flex-column align-items-center py-3 px-5 text-light text-center">

                <img *ngIf="checkisImg(current.image); else elseBlock" src="{{staticURL}}{{current.image_sq}}"
                    class="img-fluid" style="height: 30px; object-fit: contain;" alt="{{current.name}}">
                <span *ngIf="checkisImg(current.image);" style="word-break: break-all;">{{current.name}}</span>

                <ng-template #elseBlock>
                    <i class="{{current.image}} p-2" style="font-size: 1rem;"></i>
                    <span style="word-break: break-all;">{{current.name}}</span>
                </ng-template>

                <div class="d-flex flex-row gap-2 flex-wrap justify-content-center mt-2">
                    <p-tag *ngFor="let counter of current.data_counter; let i = index;" [rounded]="true"
                        icon="{{counter?.icon}} pi-fw" styleClass="bg-color-{{i}}" [pTooltip]="counter._id!">
                        {{ counter?.count }}
                    </p-tag>
                </div>

            </div> -->
            <p-progressSpinner *ngIf="loading"></p-progressSpinner>
            <ng-container *ngIf="!loading">
                <div *ngFor="let item of data" (click)="changeData(item)" [style]="{
                    '--color-1' : colors[0],
                    '--color-2' : colors[1],
                    '--color-3' : colors[2],
                    '--color-4' : colors[3],
                    '--color-5' : colors[4],
                    'cursor': 'pointer',
                     'height': 'auto'
                }"
                    class="card d-flex flex-column align-items-center py-3 px-5 {{current._id == item._id ? 'bg-primary text-light' : 'bg-light text-dark'}} text-center">


                    <img *ngIf="checkisImg(item?.image); else elseBlock" src="{{staticURL}}{{item?.image}}"
                        class="img-fluid" style="height: 50px" alt="{{item?.name}}">

                    <ng-template #elseBlock>
                        <i class="{{item?.image}} p-2" style="font-size: 1rem;"></i>
                        <span style="word-break: break-all;">{{item?.name}}</span>
                    </ng-template>

                    <div class="d-flex flex-row gap-2 flex-wrap justify-content-center mt-2">
                        <p-tag *ngFor="let counter of item?.data_counter; let i = index;" [rounded]="true"
                            [pTooltip]="counter._id!" icon="{{counter?.icon}} pi-fw" styleClass="bg-color-{{i}}">
                            {{ counter?.count }}
                        </p-tag>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="w-100 d-flex align-items-center justify-content-center">
            <p-button (onClick)="submitFilter()">{{"Submit filter" | translator}}</p-button>
        </div>
    </ng-template>
</p-dialog>